export default __webpack_public_path__ + "static/media/josue-elaniin-.02db01b9.png";